import { getApiKeyFromEnvOrThrow } from '../utils/env';

export const IS_DEV = import.meta.env.DEV;

export const DEFAULT_API_KEY = getApiKeyFromEnvOrThrow();
export const DEFAULT_BASE_URL =
  typeof process !== 'undefined' && import.meta.env.REACT_APP_API_BASE_URL
    ? import.meta.env.REACT_APP_API_BASE_URL
    : 'https://api.rango.exchange';

export const RANGO_COOKIE_HEADER = 'X-Rango-Id';
